import { render, staticRenderFns } from "./SwipeableBottomSheet.vue?vue&type=template&id=3228ea1a&scoped=true&"
import script from "./SwipeableBottomSheet.vue?vue&type=script&lang=js&"
export * from "./SwipeableBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./SwipeableBottomSheet.vue?vue&type=style&index=0&id=3228ea1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228ea1a",
  null
  
)

export default component.exports